import React, { useState } from 'react';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import CtaSection from '../sections/CtaSection';


// Import your images - make sure to place them in your assets folder
import heroImage1 from '../assets/images/brand/brand-hero-1.png';
import heroImage2 from '../assets/images/brand/brand-hero-2.png';
import videoPlaceholder from '../assets/images/brand/brand-video.png';
import philosophyImage1 from '../assets/images/brand/philosophyImage1.jpg';
import philosophyImage2 from '../assets/images/brand/philosophy-2.png';
import visionImage from '../assets/images/brand/vision-banner.png';
import storyImage1 from '../assets/images/brand/storyImage1.jpg';
import storyImage2 from '../assets/images/brand/storyImage2.jpg';
import beliefBannerImage from '../assets/images/brand/belief-banner.png';


const OurBrandScreen = () => {
  const [activeTab, setActiveTab] = useState('philosophy'); // 'philosophy' is active by default

  const renderContent = () => {
    switch (activeTab) {
      case 'philosophy':
        return (
          <div className="tab-content">
            <img src={videoPlaceholder} alt="Pouring coffee" className="content-video" />
            <h2>OUR PHILOSOPHY</h2>
            <div className="philosophy-grid">
              <div className="philosophy-item">
                <img src={philosophyImage1} alt="Zeno Filtre coffee bag and cup" />
                <h3>We Believe that</h3>
                <p>We partner with independent roasters, ceramic artists, and sustainable brands to bring you products that speak to the modern coffee lover — clean lines, muted tones, and uncompromising quality. This is more than just a store.</p>
              </div>
              <div className="philosophy-item">
                <img src={philosophyImage2} alt="French press and coffee cups" />
                <h3>Why We Do It?</h3>
                <p>We partner with independent roasters, ceramic artists, and sustainable brands to bring you products that speak to the modern coffee lover — clean lines, muted tones, and uncompromising quality. This is more than just a store.</p>
              </div>
            </div>
          </div>
        );
      case 'culture':
        return (
          <div className="tab-content">
            {/* Add content for "Our Culture" tab here */}
            <h2>OUR CULTURE</h2>
            <p>Content for Our Culture will go here. It's about our community, our baristas, and the atmosphere we create together.</p>
          </div>
        );
      case 'story':
        return (
          <div className="story-tab-container">
            {/* 1. White Background Section */}
            <div className="tab-content-wrapper white-bg">
              {/* <img src={beliefBannerImage} alt="Pouring latte art" className="content-video full-width" /> */}
              
              <div className="story-grid">
                {/* Left Column: Title -> Text -> Image */}
                <div className="story-column">
                  <h2 className="story-heading">OUR STORY</h2>
                  <div className="story-text">
                    <p>Grams began with a simple yet powerful discovery: two young entrepreneurs, traveling abroad, fell in love with specialty coffee. What started as appreciation grew into obsession—the complex flavors, the craftsmanship, the stories behind every bean.</p>
                    <p>Returning home to Morocco, we saw an opportunity. The local coffee scene was dominated by international franchises, yet there was room for something authentic, something that can honor both global standards and Moroccan identity.</p>
                    <p>Third-wave coffee deserved a Moroccan home. Not a replica of what exists elsewhere, but something genuine, built on the same uncompromising standards but rooted in our culture.</p>
                    <p>Today, Grams stands as proof that you don't need to choose between world-class quality and hometown warmth. Every cup we serve is a celebration of where we've been and where we're going—a legacy in the making, one carefully crafted coffee at a time.</p>
                  </div>
                  <img src={storyImage1} alt="French press" className="column-image output-bottom" />
                </div>

                {/* Right Column: Image -> Title -> Text */}
                <div className="story-column">
                  <img src={storyImage2} alt="Coffee beans" className="column-image output-top" />
                  <h3 className="story-subheading">Why do we do it ?</h3>
                  <div className="story-text">
                    <p>We built Grams because Morocco deserved a coffee experience that could match international standards while celebrating who we are.</p>
                    <p>Every decision we make stems from that belief. We source specialty-grade beans and train our baristas to SCA standards because quality isn't negotiable. We educate customers about origins and offer diverse brewing methods because coffee culture thrives on curiosity and knowledge. We design our spaces through sensory marketing because the atmosphere shapes experience, and we want every visit to feel intentional.</p>
                    <p>But standards alone aren't enough. We've built clear operating processes to ensure consistency, empowered customers with self-service options for efficiency, and committed to regular quality checks because excellence requires vigilance. Our third-wave principles meet Moroccan hospitality in every detail from the beans we select to the way our team connects with each customer.</p>
                    <p>Ultimately, we do this because we believe great coffee can be a bridge. Between global craft and local culture. Between precision and warmth. Between where coffee comes from and where it's going. Grams exists to prove that you don't have to choose, you can honor both, exceptionally well.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 2. Full Width Banner */}
            <section className="belief-banner" style={{ backgroundImage: `url(${beliefBannerImage})` }}>
              <div className="banner-overlay"></div>
              <div className="banner-content">
                <h2>WHAT DO WE BELIEVE IN ?</h2>
                <p>We believe that specialty coffee and Moroccan hospitality can coexist. We believe in the craft of knowing where every bean comes from, in roasting that never cuts corners, in brewing methods that honor the coffee's journey from farm to cup.</p>
              </div>
            </section>
            
            {/* 3. Beige Background Section */}
            <div className="tab-content-wrapper beige-bg">
              <div className="belief-cards-container">
                <div className="belief-card">
                  <span className="quote-mark">‘</span>
                  <h2>We believe in<br/>consistency</h2>
                  <span className="quote-mark right">’</span>
                  <p>BECAUSE RESPECT FOR OUR CUSTOMERS MEANS SHOWING UP WITH THE SAME EXCELLENCE EVERY SINGLE TIME.</p>
                </div>
                <div className="belief-card">
                  <span className="quote-mark">‘</span>
                  <h2>We believe in<br/>transparency</h2>
                  <span className="quote-mark right">’</span>
                  <p>BECAUSE GREAT COFFEE CULTURE IS BUILT ON CURIOSITY, NOT GATEKEEPING.</p>
                </div>
              </div>
              
              <div className="final-quote">
                <h2>And we believe in building bridges between worlds, between cultures, between the coffee industry's past and its future.</h2>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
        <Navbar />
      <div className="our-brand-page">
        {/* --- MODIFIED: The header is now the main container --- */}
        <header className="brand-hero">
          {/* Use only one hero image that will fill the container */}
          <img src={heroImage1} alt="Grams specialty coffee shop interior" className="hero-img-full" />
          
          {/* --- MOVED: Tabs are now inside the header for positioning --- */}
          <nav className="brand-tabs">
            <button
              className={`tab-button ${activeTab === 'philosophy' ? 'active' : ''}`}
              onClick={() => setActiveTab('philosophy')}
            >
              PHILOSOPHY
            </button>
            <button
              className={`tab-button2 ${activeTab === 'culture' ? 'active' : ''}`}
              onClick={() => setActiveTab('culture')}
            >
              CULTURE
            </button>
            <button
              className={`tab-button3 ${activeTab === 'story' ? 'active' : ''}`}
              onClick={() => setActiveTab('story')}
            >
              STORY
            </button>
          </nav>
        </header>

      
        <main className="brand-content-container">
          {renderContent()}
        </main>
        
        {/* <section className="vision-banner">
            <img src={visionImage} alt="Close up of roasted coffee beans"/>
            <div className="banner-text">
                <h2>Vision & Values</h2>
                <p>We partner with independent roasters, ceramic artists, and sustainable brands to bring you products that speak to the modern coffee lover.</p>
            </div>
        </section>

        <section className="closing-text">
            <p>Coffee is more than a drink — it's an experience, a craft, and a connection. Every bean we roast has a story, from the hands of dedicated farmers to the moment it reaches your cup. Our passion lies in treating coffee with the respect it deserves — sourcing ethically, roasting with precision, and brewing with care. We believe that every sip should inspire, comfort, and connect people, one cup at a time. That's why we do it.</p>
        </section> */}

       

      </div>
      <CtaSection />
      <Footer />
    </>
  );
};

export default OurBrandScreen;